import services from '@/services.js'
import { setItem, removeItem, getItem } from '@/utils/StorageManager'
import { getOrganizationCurrent } from '@/utils/utils.js'
import { removeUserData } from '../../../utils/StorageManager'
import router from '../../../router'
import { getLanguage } from '@/utils/languageUtils'

export default {
  register: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      services
        .register(user)
        .then((response) => {
          const data = response.data

          setItem('user', JSON.stringify(data.data))
          commit('UPDATE_REGISTER_STEP', { id: data.data.id, organizationId: data.data.organizationId })
          commit('AUTH_SUCESS_REGISTER', data.data)
          resolve(data.message)
        })
        .catch((error) => {
          commit('AUTH_ERROR', error)
          removeItem('accessToken')
          removeItem('refreshToken')
          reject(error.response)
        })
    })
  },

  registerWithInvite: ({ commit }, obj) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      services
        .registerWithInvite(obj.inviteId, obj.body)
        .then((response) => {
          const data = response.data
          setItem('user', JSON.stringify(data.data))
          console.log('Erro')
          commit('UPDATE_REGISTER_STEP', { id: data.data.userId })
          commit('AUTH_SUCESS_REGISTER', data.data)
          resolve(data.message)
        })
        .catch((error) => {
          commit('AUTH_ERROR', error)
          removeItem('accessToken')
          removeItem('refreshToken')
          reject(error.response)
        })
    })
  },

  logout: ({ commit, dispatch }, redirect = true) => {
    removeUserData()
    commit('DEFAULT_AUTH_STATE')
    commit('CLOSE_NOTIFICATION_LOOP', null, { root: true })
    commit('whitelabel/RESET_TO_DEFAULT', null, { root: true })
    dispatch('balance/steps/clearCart', null, { root: true })
    if (redirect) router.push({ name: 'Login' })
  },

  login: ({ commit }, user) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      services
        .login(user)
        .then((response) => {
          const data = response.data.data

          const accessToken = data.accessToken
          const refreshToken = data.refreshToken
          const user = data

          setItem('accessToken', accessToken)
          setItem('refreshToken', refreshToken)
          setItem('user', JSON.stringify(data))
          // setItem('hasAccountType', user.hasAccountType )
          // setItem('hasEmailValidated', user.hasEmailValidated)

          commit('AUTH_SUCESS', { user })
          resolve(response)
        })
        .catch((error) => {
          commit('AUTH_ERROR', error)
          removeItem('accessToken')
          removeItem('refreshToken')
          reject(error.response.data)
        })
    })
  },

  loginSMS: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      services
        .loginSMS(params)
        .then((response) => {
          const data = response.data.data

          const accessToken = data.accessToken
          const refreshToken = data.refreshToken
          const user = data

          setItem('accessToken', accessToken)
          setItem('refreshToken', refreshToken)
          setItem('user', JSON.stringify(data))
          // setItem('hasAccountType', user.hasAccountType )
          // setItem('hasEmailValidated', user.hasEmailValidated)

          commit('AUTH_SUCESS', { user })
          resolve(response)
        })
        .catch((error) => {
          commit('AUTH_ERROR', error)
          removeItem('accessToken')
          removeItem('refreshToken')
          reject(error.response)
        })
    })
  },

  loginExternalGoogle: ({ commit }, accessToken) => {
    return new Promise((resolve, reject) => {
      services
        .loginExternalGoogle({ accessToken })
        .then((resp) => {
          if (resp.data.success) {
            // TODO Inserir token válido
            setItem('accessToken', resp.data.data.accessToken)
            setItem('refreshToken', resp.data.data.refreshToken)
            setItem('user', JSON.stringify(resp.data.data))
            // setItem('hasAccountType', resp.data.data.hasAccountType )
            // setItem('hasEmailValidated', resp.data.data.hasEmailValidated)

            commit('AUTH_SUCESS', { user: resp.data.data })
          }
          resolve(resp.data)
        })
        .catch((error) => {
          removeItem('accessToken')
          removeItem('refreshToken')
          reject(error.response.data)
        })
    })
  },

  loginExternalLinkedin: ({ commit }, authenticationCode) => {
    return new Promise((resolve, reject) => {
      services
        .loginExternalLinkedin({ accessToken: authenticationCode })
        .then((resp) => {
          if (resp.data.success) {
            setItem('accessToken', resp.data.data.accessToken)
            setItem('refreshToken', resp.data.data.refreshToken)
            setItem('user', JSON.stringify(resp.data.data))
            // setItem('hasAccountType', resp.data.data.hasAccountType )
            // setItem('hasEmailValidated', resp.data.data.hasEmailValidated)

            commit('AUTH_SUCESS', { user: resp.data.data })
          }
          resolve(resp.data)
        })
        .catch((err) => {
          removeItem('accessToken')
          removeItem('refreshToken')
          reject(err.response.data)
        })
    })
  },

  passwordRecovery: ({ commit }, body) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      services
        .passwordRecovery(body)
        .then((response) => {
          const data = response.data
          commit('AUTH_NEW_PASSWORD')
          resolve(data.success)
        })
        .catch((error) => {
          commit('AUTH_ERROR', error)
          reject(error.response)
        })
    })
  },

  newPassword: ({ commit }, body) => {
    return new Promise((resolve, reject) => {
      commit('AUTH_REQUEST')
      services
        .newPassword(body)
        .then((response) => {
          const data = response.data
          resolve(data.success)
          commit('AUTH_NEW_PASSWORD')
        })
        .catch((error) => {
          commit('AUTH_ERROR', error)
          reject(error)
        })
    })
  },

  setOrganizationCurrent: ({ commit }) => {
    commit('AUTH_UPDATE_ORGANIZATION_ID', getOrganizationCurrent())
  },

  selectOrganization: ({ commit, dispatch }, organization) => {
    dispatch('balance/steps/clearCart', null, { root: true })
    return new Promise((resolve, reject) => {
      services
        .selectOrganization(organization.value)
        .then((res) => {
          setItem('accessToken', res.data.data.accessToken)
          setItem('refreshToken', res.data.data.refreshToken)
          let user = JSON.parse(getItem('user'))
          user.organizationId = res.data.data.organizationId
          user.organizationUserId = res.data.data.organizationUserId
          user.organizationName = organization.name
          setItem('user', JSON.stringify(user))
          // TODO
          commit('AUTH_UPDATE_ORGANIZATION_ID', {
            organizationId: res.data.data.organizationId,
            organizationUserId: res.data.data.organizationUserId,
            organizationName: organization.name,
          })
          commit('whitelabel/RESET_TO_DEFAULT', null, { root: true })
          dispatch('getUserSession', user.organizationId)
          resolve(res)
        })
        .catch((erro) => {
          reject(erro)
        })
    })
  },

  getUserSession({ commit }, organizationId) {
    return new Promise((resolve, reject) => {
      commit('DEFAULT_AUTH_STATE_SESSION')

      const requests = []
      requests.push(services.getSession(organizationId))

      if (organizationId) {
        requests.push(services.getOrganizationPlan(organizationId))
        requests.push(services.getOrganizationPlanFeatures(organizationId))
      }

      Promise.allSettled(requests)
        .then((results) => {
          let obj

          // request organizations
          if (results[0].status == 'fulfilled') {
            obj = results[0].value.data.data

            obj.user.language = getLanguage(obj.user.language)
            commit('UPDATE_LANG', obj.user.language, { root: true })
          }

          // request plans
          if (results[1]) {
            if (results[1].status == 'fulfilled') {
              obj.organization.planType = results[1].value.data.data.plan.planType
              obj.organization.planName = results[1].value.data.data.plan.name
              obj.organization.planId = results[1].value.data.data.plan.id
            }

            if (results[1].status == 'rejected') {
              throw results
            }
          }

          // request features
          if (results[2]) {
            if (results[2].status == 'fulfilled') {
              obj.features = results[2].value.data.data
            }
            if (results[2].status == 'rejected') {
              throw results
            }
          }

          commit('SET_SESSION_DATA', obj)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })

      // comentado até as suborganizations herdarem o plano da organização "mãe"
      // Promise.all(requests)
      //   .then(results => {
      //     let obj = results[0].data.data

      //     if (results[1]) {
      //       obj.organization.planType = results[1].data.data.plan.planType
      //       obj.organization.planName = results[1].data.data.plan.name
      //     }

      //     commit('SET_SESSION_DATA', obj)
      //     resolve()
      //   })
      //   .catch(error => {
      //     console.log(error)
      //     reject()
      //   })
    })
  },

  setCachedOrganizationPlanStatus({ commit }, organizationPlanStatus) {
    commit('SET_ORGANIZATION_PLAN_STATUS', organizationPlanStatus)

    // Após timeout limpa cache para checagem de status do plano
    setTimeout(() => {
      commit('RESET_ORGANIZATION_PLAN_STATUS', organizationPlanStatus)
    }, 10000)
  },
}
